import { FC } from 'react';
import Image from '../Image/Image';
import { formatImagePath } from 'src/utils/formatter';
import './style.scss';

interface IProps {
  imageWrapperClassName?: string;
}

const DonationImage: FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <Image src={formatImagePath('donation128x40.png')} aspectRatio={3} wrapperClassName={`donation-image ${props.imageWrapperClassName || ''}`} />
  );
};

export default DonationImage;
